module.exports = __webpack_public_path__ + "fonts/NHaasGroteskTXPro-75Bd.cb09d8a.woff2";